// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-page{z-index:2400}.loader-page__loader-block{height:100%}", ""]);
// Exports
module.exports = exports;
